export const onKeyEnter = (callback: () => void) => (e: any) => {
  if (e.key === "Enter") {
    callback()
  }
}